export default IconSectionSign => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-section-sign" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M9.172 19a3 3 0 1 0 2.828 -4" />
  <path d="M14.83 5a3 3 0 1 0 -2.83 4" />
  <path d="M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
</svg>`;